export default {
    // start auth
    IS_AUTHENTICATED: state => {
        return !!state.token
    },
    // end auth

    //start stores
    STORE_ID: state => {
        return state.storeId
    },
    STORES: state => {
        return state.stores
    },
    PARENT_STORES: state => {
        return state.stores.filter((store) => {
            if(store.branches.length > 0) {
                return {"id": store.id, "name": store.name}
            }
        })
    },
    BRANCHES: state => {
        if (state.parentStoreId) {
            const a = state.stores.find((store) => store.id === state.parentStoreId)
            if(a) return a.branches
        }

        var branches = state.stores.map((store) => {
            // console.log(store.branches)
            return store.branches
        })

        return [].concat.apply([], branches)
        // return []
    },
    ACCEPTING_ORDERS_STATUS: state => {
        return state.store.accepting_orders
    },
    STORE_NAME: state => {
        if(!state.store) return 'N/A'
        
        return state.store.name
    },
    PARENT_STORE_NAME: state => {
        if(!state.store) return 'N/A'

        return state.store.parent.name
    },
    STORE_ADDRESS: state => {
        return state.store.address
    }, 
    // end stores

    // start categories
    CATEGORIES: state => {
        return state.categories
    },
    CATEGORIES_ID: state => {
        return state.categoryId
    },
    // end categories

    // start products
    PRODUCTS: state => {
        return state.products
    },
    // end products

    // start cart
    CART_PRODUCTS: state => {
        return state.cartProducts
    },
    // end cart

    // start orders
    ORDER: state => {
        return state.order
    },
    ORDERS: state => {
        return state.orders
    },
    PROCESSED_ORDERS: state => {
        return state.orders.filter((order) => {
            return (order.processed === true &&
                order.fulfilled === false) 
        })
    },
    UNPROCESSED_ORDERS: state => {
        return state.orders.filter((order) => {
            return (order.processed === false &&
                order.fulfilled === false) 
        })
    },
    FULFILLED_ORDERS: state => {
        return state.orders.filter((order) => {
            return (order.processed === true &&
                order.fulfilled === true) 
        })
    },
    // end orders

    // start notifications
    ORDERS_UPDATES: state => {
        return state.ordersUpdates > 0
    },
    RECIEPTS_UPDATES: state => {
        return state.recieptsUpdates > 0
    },
    CART_UPDATES: state => {
        return state.cartUpdates > 0
    },
    // end notifications

    // start 
    PAYMENT_METHODS: state => {
        return state.paymentMethods
    },
    //end
}